<template>
    <v-container
            id="order-items"
            fluid
            tag="section"
    >
        <OrdersStats v-if="isSeller"></OrdersStats>

        <v-data-table
            v-model="selected"
            :options.sync="options"
            :loading="loading"
            :loading-text="$t('global.loading')"
            :items="orderItems"
            :server-items-length="totalItems"
            :headers="headers"
            :footer-props="footerProps"
            :no-data-text="$t('global.no_data')"
            show-select
            item-key="id"
        >

            <template v-slot:item.woo_commerce_order_id="{ item }">
                <div class="text-h6 pb-5">
                    {{item.woo_commerce_order_id}}
                </div>
                {{item.created_datetime | momentDate }}
            </template>

            <template v-slot:item.product="{ item }">
                <ProductListDetail v-bind:product="item.product"></ProductListDetail>
            </template>

            <template v-slot:item.created_datetime="{ item }">
                {{ item.created_datetime | momentDate }}
            </template>

            <template v-slot:item.paid_amount="{ item }">
                {{ $n(item.paid_amount , 'currency') }}
            </template>

            <template v-slot:item.status="{ item }">
                <v-chip
                        small
                        :class="getStatusColor(item.status)"
                >
                    {{ getStatusLabel(item.status) }}
                </v-chip>
                <v-spacer></v-spacer>

                <v-tooltip bottom
                           v-if="item.stripe_paid_out_datetime">
                    <template v-slot:activator="{ on, attrs }">
                        <v-chip
                            v-bind="attrs"
                            v-on="on"
                            class="ma-2"
                            color="white"
                            label
                            text-color="black"
                        >
                            <v-icon left>mdi-cash</v-icon>
                            {{item.stripe_paid_out_datetime | momentDateSimple }}
                        </v-chip>
                    </template>
                    Date de virement
                </v-tooltip>
                <v-tooltip bottom
                           v-else-if="item.stripe_transferred_datetime && item.stripe_paid_out_datetime === null">
                    <template v-slot:activator="{ on, attrs }">
                        <v-chip
                            v-bind="attrs"
                            v-on="on"
                            class="ma-2"
                            color="white"
                            label
                            text-color="black"
                        >
                            <v-icon left>mdi-cash</v-icon>
                            {{item.stripe_transferred_datetime | momentDateSimple }}
                        </v-chip>
                    </template>
                    Date de paiement
                </v-tooltip>
                <v-tooltip bottom
                           v-else-if="item.estimated_payment_datetime">
                    <template v-slot:activator="{ on, attrs }">
                        <v-chip
                                v-bind="attrs"
                                v-on="on"
                                class="ma-2"
                                color="white"
                                label
                                text-color="black"
                        >
                            <v-icon left>mdi-cash</v-icon>
                            {{item.estimated_payment_datetime | momentDateSimple }}
                        </v-chip>
                    </template>
                    Date de paiement estimée
                </v-tooltip>


            </template>

            <template v-slot:item.shipments="{ item }">
                <router-link :to="'/shipment/' + item.to_imparfaite_shipment_id"
                             v-if="item.to_imparfaite_shipment_id">{{
                    $t('orders.to_imparfaite') }}
                </router-link>
                <router-link :to="'/shipment/' + item.to_customer_shipment_id"
                             v-if="item.to_customer_shipment_id">{{
                    $t('orders.to_buyer') }}
                </router-link>
            </template>

            <template v-slot:item.menu="{ item }">
                <v-menu
                        v-if="item.status === 'AVAILABLE_FOR_TRANSFER' || item.status === 'TRANSFERRED'"
                        bottom left>
                    <template v-slot:activator="{ on }">
                        <v-btn
                                icon
                                v-on="on"
                        >
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item
                                v-if="item.status === 'TRANSFERRED'"
                                @click="payout([item.id])"
                        >
                            <v-list-item-title
                            >{{ $t('contextual_menu.orders.payout') }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
        <v-row>
            <v-col>
                <v-btn dark color="#f9dbc2" class="black--text" v-if="showPayout"
                       @click="payoutList()"
                >
                   Virer les pièces sélectionnées
                    <v-icon right >mdi-check-all</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-snackbar
            v-model="snackbar"
            :color="color"
        >
            {{ message }}
            <v-btn
                dark
                text
                @click="snackbar = false"
            >
                {{ $t('close') }}
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
    import mappingStatusColors from '../../../config/mapping-status-colors'
    import {mapGetters, mapState} from "vuex";
    import {createQueryString} from "@/helpers/createQueryString";
    import OrdersStats from '../components/OrdersStats'
    import ProductListDetail from "../../components/ProductListDetail";

    export default {
        name: 'Orders.List',
        components: {
            OrdersStats,
            ProductListDetail
        },
        data() {
            return {
                selected: [],
                showPayout:false,
                snackbar: false,
                color: 'info',
                message: '',
                loading: false,
                headers: [
                    {text: this.$i18n.t('orders.headers.product'), value: 'product', sortable: false, align:'left'},
                    {text: this.$i18n.t('orders.headers.ref'), value: 'woo_commerce_order_id', align: 'center', sortable: false },
                    {text: this.$i18n.t('orders.headers.status'), value: 'status', sortable: false, align: 'center'},
                    {text: this.$i18n.t('orders.headers.paid_amount'), value: 'paid_amount', sortable: false, align: 'center'},
                    {text: '', value: 'menu', sortable: false, width: '50px'},
                ],
                footerProps: {'items-per-page-options': [30], 'show-first-last-page': true},
                options: {
                    page: 1,
                    itemsPerPage: 30,
                    sortBy: ['created_datetime'],
                    sortDesc: [true],
                    groupBy: [],
                    groupDesc: [],
                    multiSort: false,
                    mustSort: false,
                },
                orderItems: [],
                totalItems: 0
            };
        },
        methods: {
            getSort() {
                if (this.queryStatus && this.queryStatus.includes('PAID')) {
                    return 'stripe_paid_out_datetime';
                }
                if (this.queryStatus && this.queryStatus.includes('TRANSFERRED')) {
                    return 'stripe_transferred_datetime';
                }

                return 'created_datetime';
            },
            displayOverlay() {
                console.log(this.store);
                this.overlay = this.store.stripe_account_id === null;
            },
            load() {
                this.loading = true;
                this.orderItems = [];
                let params = {page: this.options.page, ...this.$route.params, ...this.$route.query, ...this.filters, order: {}};

                // Define sorting parameters.
                if (this.options.sortBy.length) {
                    params.order[this.getSort()] = this.options.sortDesc[0] ? 'desc' : 'asc';
                }

                this.$axios.get('order_items?' + createQueryString(params))
                    .then(response => {
                        this.loading = false;
                        this.orderItems = response.data['hydra:member'];
                        this.totalItems = response.data['hydra:totalItems'];
                    });
            },
            payoutList() {
                let order_items = [];
                this.selected.forEach((order_item) => {
                    order_items.push(order_item.id);
                });

                if (order_items.length > 0) {
                    this.payout(order_items);
                }
            },
            payout(order_item_ids) {
                if (order_item_ids.length < 1) {
                    this.snackbar = true;
                    this.message = this.$i18n.t('orders.payout_failed');
                    this.color = 'error';
                    return;
                }

                this.loading = true;
                this.$axios.post('payouts', {order_item_ids: order_item_ids})
                    .then(() => {
                        this.loading = false;
                        this.snackbar = true;
                        this.message = this.$i18n.t('orders.payout_done');
                        this.color = 'info';
                    })
                    .catch(() => {
                        this.loading = false;
                        this.snackbar = true;
                        this.message = this.$i18n.t('orders.payout_failed');
                        this.color = 'error';
                    });
            },
            getStatusLabel(status) {
                return this.$i18n.t('orders.status.' + status.toLowerCase())
            },
            getStatusColor(status) {
                return mappingStatusColors[status];
            },
        },
        watch: {
            queryString: {
                handler() {
                    this.load();
                    if (this.queryStatus && this.queryStatus.includes('TRANSFERRED')) {
                        this.showPayout = true;
                    }
                }
            }
        },
        computed: {
            ...mapGetters(['isAdmin', 'isSeller']),
            ...mapState(['userInformation']),
            queryString: function () {
                return createQueryString({page: this.options.page, ...this.$route.params, ...this.$route.query});
            },
            queryStatus: function () {
                return this.$route.query['status[]'] || this.$route.query['status'] || [];
            },
        },
        mounted() {
            this.load();
        }

    }
</script>
